export const environment = {
  production: false,
  apiBase: 'https://stage.api.dosportnow.com',
  // apiBase: 'http://10.10.10.117:3000',
  apiEndpoint: 'admin'
};
